import { STATUS_MAP } from "@helpers/constant";

export default function prepareDetails(details) {
  const parts = [];

  for (const [key, value] of Object.entries(details)) {
    parts.push(`${key}=${value}`);
  }

  return parts.join(";");
}

export const normalizeStatusCode = (statusCode) => {
  if (typeof statusCode === "string") return statusCode;
  
  return statusCode
    .filter((x) => x.selected)
    .map((x) => x.id)
    .join(";");
};

export const getStatusStyle = (installStatus) => {
  const s = STATUS_MAP[String(installStatus)] || {
    label: String(installStatus),
    color: "grey",
  };
  return {
    backgroundColor: s.color,
    color: "white",
    padding: "2px 8px",
    borderRadius: 4,
    display: "inline-block",
  };
};
